import { useAction, useAtom } from '@reatom/npm-react';
import { manrope } from '@trwl/app/fonts';
import { APP_STORE_LINK, PLAY_MARKET_LINK } from '@trwl/constants';
import { IsPWA, IsTelegram } from '@trwl/hooks';
import { Container } from '@trwl/layout';
import { appBannerAtom } from '@trwl/store/atoms';
import cn from 'classnames';
import Link from 'next/link';
import { useCallback } from 'react';
import { isMobile, isSafari, isAndroid } from 'react-device-detect';
import { CgClose } from 'react-icons/cg';

export const AppBanner = () => {
  const [cookie] = useAtom(appBannerAtom.cookieAtom);
  const setVisible = useAction(appBannerAtom.set);
  const isPwa = IsPWA();
  const isTelegram = IsTelegram();

  const onCloseAppBanner = useCallback(() => {
    setVisible('appBannerIsHide', 'true', {
      maxAge: 7 * 24 * 60 * 60,
    });
  }, [setVisible]);

  const appLink = isAndroid ? PLAY_MARKET_LINK : APP_STORE_LINK;

  const isMobileBrowserExcludingPwaAndSafari =
    isMobile && ((!isSafari && !isPwa) || isTelegram);
  if (
    !isMobileBrowserExcludingPwaAndSafari ||
    cookie?.appBannerIsHide === 'true'
  )
    return null;

  return (
    <div className={'w-full text-center py-1 bg-[#DDDDDD]'}>
      <Container className={'pl-3 py-2'}>
        <div
          className={cn(
            'flex flex-row justify-between items-center gap-[20px]',
            manrope.className,
          )}
        >
          <div
            className={'flex flex-row items-center justify-start gap-[10px]'}
          >
            <CgClose
              className="cursor-pointer w-[16px] h-[16px] fill-[#808080] p-[1px]"
              onClick={onCloseAppBanner}
            />
            <svg
              width="47"
              height="47"
              viewBox="0 0 47 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="47" height="47" rx="9" fill="black" />
              <path
                d="M13.1501 22.82H11.2501V26.7C11.2501 27.44 11.5101 27.74 12.2301 27.74H12.6501V30.02H11.5701C9.83008 30.02 8.79008 29.14 8.79008 27.28V22.82H7.09008V20.76H8.79008V17.06H11.2501V20.76H13.1501V22.82ZM20.2098 20.48V23.12H19.9298C17.9698 23.12 17.0298 23.96 17.0298 26.22V30H14.5898V20.76H17.0098V22.72H17.0498C17.5298 21.28 18.5898 20.48 20.1098 20.48H20.2098ZM32.9843 20.76H35.5443L32.3243 30H30.1443L28.0243 23.96L25.9043 30H23.7243L20.5043 20.76H23.0643L24.8443 26.84L26.8643 20.76H29.1843L31.2043 26.84L32.9843 20.76ZM39.0234 16V30H36.5634V16H39.0234Z"
                fill="white"
              />
            </svg>
            <div
              className={'text-start text-[15px] leading-[20px] font-medium'}
            >
              Быстрее и удобнее <br />в приложении
            </div>
          </div>
          <Link
            href={appLink}
            target={'_blank'}
            className={
              'cursor-pointer w-[88px] h-[30px] bg-[#0A84FF] flex items-center justify-center text-[15px] leading-[15px] text-white rounded-full font-bold'
            }
          >
            Открыть
          </Link>
        </div>
      </Container>
    </div>
  );
};
